export enum itemTypes {
    siteFavourites, bookmarkCard, myFavourites, allFavorites
}